import {
  CalloutComponent,
  CheckBox,
  ConfirmDialogProps,
  FormValues,
  InfoBlockStatus,
  InputFormCallout,
} from "o4a-react";
import * as React from "react";
import { Text } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";

export interface AdbsNetworkMtlsEditPanelProps extends
  Pick<ConfirmDialogProps, "targetId" | "onCancel"> {
  isMtlsConnectionRequired: boolean | undefined;
  onSubmit: (formValues: FormValues) => void;
  componentRef?: (ref: CalloutComponent) => void;
}

export const Fields = { MTLSAuthentication: "mTLSAuthentication" };

export const AdbsNetworkMutualAuthEditPanel = (
  { isMtlsConnectionRequired, targetId, onCancel: onClose, onSubmit, componentRef }: AdbsNetworkMtlsEditPanelProps,
): JSX.Element => (
  <InputFormCallout
    componentRef={componentRef}
    title={Messages.createNewPanels.editNetworkingMTLS.title()}
    targetId={targetId}
    onSubmit={(formValues: FormValues) => {
      onSubmit(formValues);
    }}
    onClose={() => {
      if (onClose) {
        onClose();
      }
    }}
  >
    <Text variant="medium">
      {Messages.labels.requiretMTLSAuthentication()}
    </Text>
    <CheckBox
      defaultValue={isMtlsConnectionRequired}
      fieldName={Fields.MTLSAuthentication}
      statusInfo={{
        messageType: InfoBlockStatus.INFO,
        message: Messages.hints.requiretMTLSAuthentication(),
      }}
    />
  </InputFormCallout>
);
